function getExercise() {
    var Pageurl = '/pages/workout';
    if (window.location.href.includes(Pageurl)) {
        playVideoWorkout();
        const params = new URLSearchParams(window.location.search);
        const exercisesCode = params.get('id');
        getPageIssue();
        var videoId;
        var embedUrl;
        var videoThumb;
        var settings = {
            "url": "https://backend-main-zu9ki2.laravel.cloud/api/shopify/show_lesson",
            "method": "POST",
            "timeout": 0,
            "headers": {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxOSIsImp0aSI6IjE5N2I2OTg3OTY3ZjNlYWQ0YTdjMGFkMTIzMzJjMmFkMzJmZDUxMmQzNWI4ODg5MTAzNTE2ODU3NWIzY2YwZmExYWE2YWQxODU3NzliNjMwIiwiaWF0IjoxNzcwOTgwMjIxLjMxNDkzOCwibmJmIjoxNzcwOTgwMjIxLjMxNDkzOSwiZXhwIjoxODAyNTE2MjIxLjMwOTIzOSwic3ViIjoiMTkiLCJzY29wZXMiOlsiKiJdfQ.ftCrIpw4LsnjUzpDWzciH0h_jJjJoLbGpqeoOrFSrrg3ldAR1vGTP50rwvENLmcflo_G9Woo4yC4gHQ42FY0jbIx9WUcn9p0BPxCqmQLkHHjL3E0__Ddr28_9RWiMC24ybrHgqLeJSvsmHKLLt1Cqv_zNJddS4JgnO0PcRPVeML9Xb0m3AD-Hq0RH4T9cGDLiERABAjR-5ANy2Iu8ESafBGzudp8tw3Ad2sBNLUsZTRRZ_PLOab_-RgPID2VbDicFWRuOlvYDNiYlplDSJTeTeW6wjmwOYel5j-AK53QKtr99iYzKDqqaV4hU3yz-YefLLCtIkP0UBJMgiGirohCHzTCEsFdCDwpyXstT2tR6ePpdpOyHgcE0Z6pocgoY4z9U0Tic1jqE7E5DxBL37rcMABItZMtsAc7pDiJ_6tcDMLPHu4IVVtaUn-Erckf5HKw2kFEGxjye1DbwHEowothntcOTWX2RUaN5Sd-5nJuG2oyQUyfP-kAkSW4rytJ_h8o1cXQGhJt22sg3kAe1-o26ZU74XYF_n7NQ3PQ-91IIEXoAES_-RGM6e4lu7-BWS76nYDuL1hSvsBvcgTjUcEDIHbtstHGrWL8ihMaKAB3RknHHNjmUtnu-tjv-Ce3q7posCbz67XdulWuCTQXayw8DoefkY7sIjiNcIKNzdwNFns"
            },
            "data": JSON.stringify({
                "id": exercisesCode
            }),
        };
        $.ajax(settings).done(function (item) {
            $(".exercise-title").text(item.exercise_name);

            checkExercise(item.duration,item.repetitions,item.extra);
            
            $(".video_thumb").attr("src","https://img.youtube.com/vi/"+item.video_url+"/maxresdefault.jpg");
            $(".video_embed").attr("src","https://www.youtube.com/embed/"+item.video_url+"?enablejsapi=1&rel=0&controls=1&modestbranding=1");

            if (item.weight != null) {
                $(".weight").text(item.weight);
            }else{
               $(".weight").text("Corpo libero"); 
            }
            Object.entries(item).forEach(([key, value]) => {
                if (key === 'muscles') {
                    value.forEach(m => $(".focus").text(m.description));
                    return;
                }
                $(`.ex-${key}`).text(value); 
            });
        });
        function videoParam(video_url){
            videoId = video_url;
            substr = 'embed';
            if (videoId.includes(substr)) {
                urlSplit1 = videoId.split('https://');
                urlSplit2 = urlSplit1[1].split('/');
                urlSplit3 = urlSplit2[2].split('?');
                videoId = urlSplit3[0];

                embedUrl = 'https://www.youtube.com/embed/'+videoId+'?enablejsapi=1&rel=0&controls=1&modestbranding=1'
                videoThumb = 'https://img.youtube.com/vi/'+videoId+'/maxresdefault.jpg';

                $(".video_thumb").attr("src",videoThumb);
                $(".video_embed").attr("src",embedUrl);
            }else{
                urlSplit1 = videoId.split('https://');
                urlSplit2 = urlSplit1[1].split('/');
                videoId = urlSplit2[1];
                embedUrl = 'https://www.youtube.com/embed/'+videoId+'?enablejsapi=1&rel=0&controls=1&modestbranding=1'
                videoThumb = 'https://img.youtube.com/vi/'+videoId+'/maxresdefault.jpg';

                $(".video_thumb").attr("src",videoThumb);
                $(".video_embed").attr("src",embedUrl);
            }
        }
        function checkExercise(duration,rep,extra){
            const formatDuration = (s) => {
                if (!s || s <= 0) return '';
                if (s < 60) return `${s} sec`;
                const mins = Math.floor(s / 60);
                const secs = s % 60;
                return secs > 0 ? `${mins}m ${secs}s` : `${mins} min`;
            };
            if (rep != null) {
                if (extra != null) {
                    $(".extra").html(rep +" reps<br/>"+ extra);
                }else{
                    $(".extra").html(rep +" reps<br/>");                
                }
                $(".extra").html(rep +" reps");
            }else if (duration != null) {
                if (extra != null) {
                    $(".extra").html(formatDuration(duration) +"<br/>"+ extra);
                }else{
                    $(".extra").html(formatDuration(duration) +"<br/>");                
                }
                $(".extra").html(formatDuration(duration));
            }else{
               $(".extra").text(extra); 
            }
        }
    }
    function playVideoWorkout() {
        $('.workout-video').on('click', function() {
            $('.workout-play').hide();
            const $container = $(this);
            const $iframe = $container.find('iframe');
            const videoSrc = $iframe.attr('src');

            $container.addClass('is-active');

            // Se non c'è già l'autoplay, lo aggiungiamo all'URL dell'iframe
            if (videoSrc.indexOf('autoplay=1') === -1) {
                const newSrc = videoSrc + (videoSrc.includes('?') ? '&' : '?') + "autoplay=1&mute=1";
                $iframe.attr('src', newSrc);
            }
        });
    }
    function getPageIssue() {
        // 1. Logica dello Sticky Stop prima del footer
        const $triggerBug = $('#bug-trigger');
        const $overlay = $('#bug-modal-overlay');
        const $footer = $('.site-footer');
        const $trigger = $('#bug-trigger');
        if ($footer.length) {
            $(window).on('scroll resize', function() {
            const windowHeight = $(window).height();
            const scrollTop = $(window).scrollTop();
            const footerTop = $footer.offset().top;
            
            // Calcola quando il trigger tocca il footer
            const triggerBottomDistance = 20; // Corrisponde al 'bottom' del CSS
            const footerVisibleTrigger = (scrollTop + windowHeight) - footerTop;
            
            if (footerVisibleTrigger > 0) {
                $triggerBug.css({
                'bottom': (footerVisibleTrigger + triggerBottomDistance) + 'px'
                });
            } else {
                $triggerBug.css('bottom', triggerBottomDistance + 'px');
            }
            });
        }
        $(document).on('click','#bug-trigger', function() {
            $overlay.addClass('is-open');
            $('#bug-message').focus(); 
        });
        $('.bug-modal-close, #bug-modal-overlay').on('click', function(e) {
            if (e.target === this) {
            $overlay.removeClass('is-open');
            }
        });

        $('.id-submit-bug').on('click', function(e) {
            e.preventDefault();
            const messaggio = $('#bug-message').val().trim();
            
            if (messaggio === '') {
                $('#bug-message').css('border-color', 'red'); 
                return false;
            }else{    
                //Send data
                const params = new URLSearchParams(window.location.search);
                const exercisesCode = params.get('id');
                var settings = {
                    "url": "https://backend-main-zu9ki2.laravel.cloud/api/shopify/lesson-report/submit",
                    "method": "POST",
                    "timeout": 0,
                    "headers": {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxOSIsImp0aSI6IjE5N2I2OTg3OTY3ZjNlYWQ0YTdjMGFkMTIzMzJjMmFkMzJmZDUxMmQzNWI4ODg5MTAzNTE2ODU3NWIzY2YwZmExYWE2YWQxODU3NzliNjMwIiwiaWF0IjoxNzcwOTgwMjIxLjMxNDkzOCwibmJmIjoxNzcwOTgwMjIxLjMxNDkzOSwiZXhwIjoxODAyNTE2MjIxLjMwOTIzOSwic3ViIjoiMTkiLCJzY29wZXMiOlsiKiJdfQ.ftCrIpw4LsnjUzpDWzciH0h_jJjJoLbGpqeoOrFSrrg3ldAR1vGTP50rwvENLmcflo_G9Woo4yC4gHQ42FY0jbIx9WUcn9p0BPxCqmQLkHHjL3E0__Ddr28_9RWiMC24ybrHgqLeJSvsmHKLLt1Cqv_zNJddS4JgnO0PcRPVeML9Xb0m3AD-Hq0RH4T9cGDLiERABAjR-5ANy2Iu8ESafBGzudp8tw3Ad2sBNLUsZTRRZ_PLOab_-RgPID2VbDicFWRuOlvYDNiYlplDSJTeTeW6wjmwOYel5j-AK53QKtr99iYzKDqqaV4hU3yz-YefLLCtIkP0UBJMgiGirohCHzTCEsFdCDwpyXstT2tR6ePpdpOyHgcE0Z6pocgoY4z9U0Tic1jqE7E5DxBL37rcMABItZMtsAc7pDiJ_6tcDMLPHu4IVVtaUn-Erckf5HKw2kFEGxjye1DbwHEowothntcOTWX2RUaN5Sd-5nJuG2oyQUyfP-kAkSW4rytJ_h8o1cXQGhJt22sg3kAe1-o26ZU74XYF_n7NQ3PQ-91IIEXoAES_-RGM6e4lu7-BWS76nYDuL1hSvsBvcgTjUcEDIHbtstHGrWL8ihMaKAB3RknHHNjmUtnu-tjv-Ce3q7posCbz67XdulWuCTQXayw8DoefkY7sIjiNcIKNzdwNFns"
                    },
                    "data": JSON.stringify({
                        "cid": workoutConfig?.cid,
                        "sig": workoutConfig?.sig,
                        "id": exercisesCode,
                        "message": messaggio
                    }),
                };
                $.ajax(settings).done(function (item) {
                    console.log('Segnalazione inviata:', messaggio);
                    
                    $(this).find('span').text('Inviato!');
                    setTimeout(function() {
                        $overlay.removeClass('is-open');
                        $('#bug-message').val('').css('border-color', '#000'); // Reset
                        $('.id-submit-bug span').text('Invia');
                    }, 1200);
                });
            }
        });
    }
}